$(window).scroll(function() {
  let header = $('#header');
  if(header.length > 0 ) {
    let sticky = parseFloat(header.offset().top);
    if($(window).scrollTop() >= 130) {
      header.addClass("pos-fixed");
    } else {
      header.removeClass("pos-fixed");
    }
  }
});